async = App.load 'bower::async/lib/async'

class exports.JsDbLoader

    constructor: (@registry = {}, @instances = {}) ->
        undefined

    ###
     * Register a new JsDB DB class
    ###
    register: (name, dbclass) ->
        @registry[name] = dbclass


    ###
     * Load data for multiple DBs. For instance, say I have a 'hybrids' and a 'treatments'
     * DB registered. I could pass in:
     *  {
     *       'hybrids': [(list of records...)]
     *       'treatments': [(list of records...)]
     *  }
     *
     * And both would be populated
    ###
    load: (dbData, callback = -> undefined) ->
        dbs = []

        pushRecord = (name, data) =>
            if @exists(name)
                dbs.push { instance: @getDbInstance(name), records: data }


        for name, data of dbData
            pushRecord(name, data)

        if dbs.length is 0
            return callback {}

        async.map dbs, @_initializeDb, callback


    ###
     * Same as `load()`, but it reads the `jsdb` component
     * of a JSONResponse and populates the DBs
    ###
    loadJsonResponse: (response, callback = -> undefined) ->
        if not response.jsdb?
            return callback({})

        @load(response.jsdb, callback)



    _initializeDb: (dbinfo, callback) =>
        dbinfo.instance.initialize dbinfo.records, (err, result) =>
            callback(err, dbinfo.instance)


    ###
     * Tests if the given DB class exists in @registry
    ###
    exists: (name) ->
        if @registry[name]?
            return true

        return false


    ###
     * Returns an instance from the list
    ###
    get: (name) ->
        return @instances[name] if @instances[name]?

    ###
     * Creates a new instance of the given `name` database.
     * If the database name doesn't exist in @registry, an error is thrown.
    ###
    getDbInstance: (name) =>
        db = @registry[name]

        if not db?
            throw Error "JsDb doesn't have #{name} registered"

        if typeof db is 'string'
            object = window.App.loadClass(db)
        else
            object = db

        instance = new object()

        @instances[name] = instance

        return instance
